/**
 * Models a list of group-by categories contained in a data property.
 * It cannot be a collection given the format the API produces.
 */

import Backbone from "backbone";

const Model = Backbone.Model.extend({
  defaults: {
    formParamName: null,
    data: [],
  },
});

export { Model as default };
